module.exports = __webpack_public_path__ + "img/gotfertomi-coussins-6.645f3410.jpg";